export default "__VITE_ASSET__6Sr2oRPq__"